<template>
  <div class="bigBox">
    <Header class="headBox" />
    <!-- head title -->
    <div class="titleBox">
      <img src="../../assets/images/titleIcon.png" alt="" />
      <p>
        El cliente tiene conocimiento que la información está sujeta a
        evaluación y verificación. En caso la información haya sido ingresada de
        manera incompleta, errónea o falsa, no se aprobará la solicitud del
        crédito.
      </p>
    </div>
    <!-- identify main -->
    <div class="mainBox">
      <div class="cameraBox">
        <img src="../../assets/webImg/identifyLoding.png" alt="" />
        <FaceRecognition
          @openloading="openloading"
          ref="cameraRef"
          @complate="complate"
          @setBtnState="setBtnState"
        />
      </div>
      <p class="titleText">
        Por favor coloque su cara en el marco y no se mueva después de hacer
        click en <span>EMPEZAR A VERIFICAR</span>
      </p>
      <div
        @click="photograph"
        class="photographBtn"
        :style="{ backgroundColor: btnDisabled ? '#ccc' : '' }"
      >
        EMPEZAR A VERIFICAR
      </div>
      <img
        style="width: 6.07rem"
        src="../../assets/webImg/ruleImg.png"
        alt=""
      />
    </div>
    <ContactOrAbout />

    <van-overlay :show="loading">
      <div class="loadingIcon">
        <i class="el-icon-loading"></i>
        <p>
          loading...
        </p>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import FaceRecognition from "../../components/faceRecognition.vue";
import Header from "../../components/webComponents/header.vue";
import ContactOrAbout from "../../components/webComponents/contactOrAbout.vue";
import { orderConfirm } from "../../utils/api/h5page";
import { Dialog } from "vant";
export default {
  components: {
    Header,
    FaceRecognition,
    ContactOrAbout,
  },
  name: "",
  props: {},
  data() {
    return {
      loading: false,
      btnDisabled: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    photograph() {
      if (this.btnDisabled) {
        return this.$refs.cameraRef.openTitleVisible();
      }
      this.$refs.cameraRef.photoShoot();
    },
    complate() {
      const jsonData = JSON.parse(sessionStorage.getItem("jsonData"));
      const params = {
        loan: jsonData.loanNum,
        period: jsonData.loanDay,
        is_new: 1,
        coupon_id: "",
        order_label: "FAST_RELOAN",
        token_key: localStorage.getItem("tokenKey"),
      };
      if (!localStorage.getItem("tokenKey")) {
        this.loading = false;
        return Dialog.alert({
          message:
            "Este navegador no es compatible con los servicios relacionados con MasterSol, por lo que no podemos recibir su solicitud. Por favor, cambie de navegador y continúe enviando.",
          theme: "round-button",
          confirmButtonText: "copy",
        }).then(() => {
          // on close
          if (window.location.host == "www.mastersol.tech") {
            navigator.clipboard.writeText("https://www.mastersol.tech/home");
          } else {
            navigator.clipboard.writeText(
              "https://mastersol.jinglewill.com/211345390/#/home"
            );
          }
        });
      }
      // this.loading = true;
      orderConfirm(params).then(({ data }) => {
        if (data.code == 0) {
          this.$router.push({ path: "/homeWeb" });
        } else if (data.code == 500) {
          this.$Toast("error");
          this.loading = false;
        }
      });
    },

    openloading() {
      this.loading = true;
    },

    setBtnState(row) {
      this.btnDisabled = row;
    },
  },
};
</script>

<style lang="scss" scoped>
.bigBox {
  background-color: #fff;
}
.headBox {
  position: relative;
}
.titleBox {
  position: relative;
  display: flex;
  align-items: center;
  width: 11.13rem;
  height: 0.9rem;
  background: #fbf7ec;
  border-radius: 0.1rem;
  margin: 0.2rem auto 0.32rem;
  padding: 0 0.15rem;
  img {
    width: 0.6rem;
    height: 0.6rem;
    margin-right: 0.14rem;
  }
  p {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.14rem;
    color: #8a7a51;
    line-height: 0.25rem;
  }
}

.mainBox {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: #ffffff;
  border-radius: 0.2rem;
  padding: 0.52rem 0 0;
  .cameraBox {
    position: relative;
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    overflow: hidden;
    img {
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      animation: roteImg 1s linear infinite;
    }
  }
  .titleText {
    width: 7rem;
    text-align: center;
    font-size: 0.28rem;
    line-height: 0.37rem;
    color: #333;
    margin: 0.32rem 0 0.4rem;
    span {
      font-size: 0.28rem;
      line-height: 0.33rem;
      color: #333;
      font-weight: 700;
    }
  }

  .photographBtn {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 5.8rem;
    height: 0.8rem;
    background: #c90000;
    border-radius: 0.4rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.32rem;
    color: #ffffff;
    margin-bottom: 0.5rem;
  }
}

.loadingIcon {
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -70%);
  font-size: 0.35rem;
  color: #409eff;
  i {
    font-size: 0.65rem;
    margin-bottom: 0.2rem;
  }
}

.van-overlay {
  z-index: 25;
}

@keyframes roteImg {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
